<a
  class="message-tile collapsed"
  data-test="message-tile"
  [attr.data-test-id]="message.id"
  routerLink="/message-center"
  [queryParams]="{
    messageId: message.id,
    messageType: 'claims'
  }"
>
  <!-- todo: in future 'claims' -> message.type -->
  <div
    class="unread-indicator"
    [attr.data-test]="'message-is-' + (message.isRead ? 'read' : 'unread')"
  >
    <span
      data-test="span-unread-dot"
      class="unread-dot"
      *ngIf="!message.isRead"
    ></span>
  </div>

  <div class="message">
    <div class="summary">
      <span class="date" data-test="message-date">{{
        message.created | date: 'shortDate'
      }}</span>
      <span
        class="title cg-font-size-m cg-link-color cg-margin-top-xs"
        data-test="message-title"
        >{{ message.subject }}</span
      >
      <span class="text cg-margin-top-xs" data-test="message-text">{{
        message.desc
      }}</span>
    </div>
  </div>

  <cigna-icon class="link-icon cg-link-color" type="chevron-right"></cigna-icon>
</a>
